import React, { useContext, useEffect } from "react";
import { connect } from "react-redux";
import AbsoluteDrawer from "./AbsoluteDrawer";
import ActiveRoutesIndexMap from "../../../components/Maps/ActiveRoutes/IndexMap";
import { ActiveRouteDataContext } from "../../../components/Maps/ActiveRoutes/ActiveRouteDataLayer";
import OverwritingContent from "./OverwritingContent";

const ActiveRoutesEmbeddedPage = ({ children }) => {
  const { offJobStaff, activeRoutes, activeRoutesQuery } = useContext(
    ActiveRouteDataContext,
  );
  // Setup a function for communication with the mobile app:
  useEffect(() => {
    window.snowscapeActiveRoutesUpdateData = () => {
      activeRoutesQuery.refetch();
    };
    return () => {
      window.snowscapeActiveRoutesUpdateData = undefined;
    };
  }, [activeRoutesQuery]);

  return (
    <>
      <AbsoluteDrawer>
        <OverwritingContent>
          <ActiveRoutesIndexMap
            activeRoutes={activeRoutes}
            offJobStaff={offJobStaff}
          />
        </OverwritingContent>
        {children}
      </AbsoluteDrawer>
    </>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(ActiveRoutesEmbeddedPage);
